import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import SOActions from '@Actions/sales/soActions';
import Helpers from '@Apis/helpers';
import './style.scss';
import { toISTDate } from '@Apis/constants';
import documentUINamesConstant from '../../../../../apis/documentUINamesConstant';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';

/**
 *
 */
class SalesOrderList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

    this.state = {
      currentPage: 1,
      startDate: dayjs().valueOf(),
      openSelectedDuration: dayjs().subtract(300, 'd').valueOf(),
      closedSelectedDuration: 'LAST 60 DAYS',
      tableColumns: [
        {
          title: '',
          render: (record) => (
            <Link to={`/sales/sales-order/view/${record.order_id}`}>
              <div className="mobile-list__item">
                <div style={{ display: 'flex' }}>
                  <H3Text text={`#${record?.sales_order_number}`} className="mobile-list__item-number" />
                  <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
                    {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  </div>
                </div>
                { record?.customer_info && (
                  <div className="mobile-list__item-info">
                    {`Customer - ${record?.customer_info?.customer_name}`}
                  </div>
                )}
                <H3Text text={`Order Total - ${this.props.MONEY(record?.order_grand_total || '0')}`} className="mobile-list__item-info" />
                {/* <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" /> */}
                <div className="vendor-mobile-list__item-footer">
                  <H3Text text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer-left" />
                </div>
              </div>
            </Link>
          ),
          responsive: ['xs'],
        },
        {
          title: 'SO NUMBER',
          dataIndex: 'sales_order_number',
          responsive: ['sm', 'md', 'lg', 'xxl'],

        },
        {
          title: 'ITEMS',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (item) => item?.sales_order_lines?.filter((invoice) => invoice.status !== 'CANCELLED').length,
        },
        {
          title: 'ORDER DATE',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (record) => (
            <div>
              {dayjs(record?.order_date).format('DD/MM/YYYY')}
              <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
            </div>
          ),
        },
        {
          title: 'DELIVERY DATE',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (record) => (
            <Fragment>
              {dayjs(record?.delivery_date).format('DD/MM/YYYY')}
            </Fragment>
          ),
        },
        {
          title: 'ORDER TOTAL AMOUNT',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (item, record) => ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view order total amount"} /> : this.props.MONEY((record?.order_grand_total || '0'), record?.org_currency_info?.currency_code)),
        },
        {
          title: 'STATUS',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (item) => (
            <Fragment>
              <div style={{ display: 'flex' }}>
                <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
                  { Helpers.getStatusColor(item.status).text}
                </div>
              </div>
            </Fragment>
          ),
        },
        {
          title: '',
          key: 'action',
          fixed: 'right',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (record) => {
            const { history, user } = this.props;
            return (
              <div style={{
                textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
              }}
              >
                <div
                  className="customer-sales-order-view-button"
                  onClick={() => {
                    history.push(`/sales/sales-order/view/${record?.order_id}`);
                  }}
                >
                  View
                </div>

              </div>
            );
          },
        },
      ],
      showNewCustomerModal: false,
      showUpdateCustomerModal: false,
      searchKeyword: '',
      mobileVendorsLength: 10,
      documentUINames: {},
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getSOSuccess } = this.props;
    getSOSuccess(null);
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    const { customerId } = props.match.params;

    if (props.user && !state.isUserReady) {
      const { currentPage } = state;
      const { getSO, user } = props;
      getSO({
        orgId: user?.tenant_info?.org_id,
        tenantId: user?.tenant_info?.tenant_id,
        customerId,
        page: currentPage,
        limit: 10,
        orderType:'SALES_ORDER',
      }, () => {});
      return {
        ...state,
        documentUINames: documentUINamesConstant(props.user),
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      salesOrders, getSOLoading, user, getSO, match,
    } = this.props;
    const {
      currentPage, tableColumns, searchKeyword, keyword, documentUINames,
    } = this.state;
    const { customerId } = match.params;

    return (
      <Fragment>
        <div className="customer-sales-orders__wrapper">
          <div className="ant-row">
            <div className="ant-col-xs-24">
              <div className="customer-sales-orders__table__wrapper">
                {searchKeyword && searchKeyword.length > 0 && (
                  <div className="search-bar__search-container__clear-button">
                    <H3Text
                      text={(
                        <React.Fragment>
                          Showing search results for&nbsp;
                          <i>
                            <b>
                              {`'${searchKeyword}'`}
                            </b>
                          </i>
                        </React.Fragment>
                      )}
                      className="section-search-keyword"
                    />
                    <H3Text
                      text="clear"
                      className="search-bar__clear-button"
                      onClick={() => {
                        this.setState({ searchKeyword: '', keyword: '', currentPage: 1 });
                        getSO({
                          orgId: user?.tenant_info?.org_id,
                          tenantId: user?.tenant_info?.tenant_id,
                          customerId,
                          page: 1,
                          limit: 10,
                          listScreen: true,
                          orderType:'SALES_ORDER',
                        }, () => {});
                      }}
                    />
                  </div>
                )}
                <div className="customer-sales-orders__table__data">
                  <Table
                    title={() => `${(salesOrders && salesOrders?.data?.count) ? salesOrders?.data?.count : '0'} Total ${documentUINames?.salesOrderUIName}s`}
                    loading={getSOLoading}
                    showHeader
                    size="small"
                    scroll="scroll"
                    columns={tableColumns}
                    dataSource={salesOrders && salesOrders?.data?.sales_orders ? salesOrders?.data?.sales_orders : []}
                    pagination={salesOrders?.data?.count > 10 ? {
                      defaultCurrent: 1,
                      current: currentPage,
                      total: salesOrders ? salesOrders?.data?.count : 0,
                      pageSize: 10,
                      onChange: (page) => {
                        this.setState({ currentPage: page });
                        getSO({
                          orgId: user?.tenant_info?.org_id,
                          tenantId: user?.tenant_info?.tenant_id,
                          customerId,
                          page: currentPage,
                          limit: 10,
                          searchKeyword: keyword,
                          listScreen: true,
                          orderType:'SALES_ORDER',
                        }, () => {});
                      },
                      position: ['bottomRight'],
                      showSizeChanger: false,
                    } : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, SOReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getSOLoading: SOReducers.getSOLoading,
  salesOrders: SOReducers.salesOrders,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getSO: (payload, limit) => dispatch(SOActions.getSO(payload, limit)),
  getSOSuccess: (salesOrders) => dispatch(SOActions.getSOSuccess(salesOrders)),

});

SalesOrderList.propTypes = {
  getSO: PropTypes.func,
  salesOrders: PropTypes.any,
  user: PropTypes.any,
  getSOLoading: PropTypes.bool,
  customerId: PropTypes.any,
  params: PropTypes.any,
  match: PropTypes.any,
  getSOSuccess: PropTypes.func,
  history: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SalesOrderList));
